import { Pipe, PipeTransform } from '@angular/core';
import { MaskPipe } from 'ngx-mask';

@Pipe({
  name: 'cpfCnpjMask'
})
export class CpfCnpjMaskPipe implements PipeTransform {

  constructor(private maskPipe: MaskPipe) { }

  transform(documento: string, args?: any): any {
    if (!documento)
      return this.maskPipe.transform(documento, '0*');

    if (documento.length <= 11)
      return this.maskPipe.transform(documento, '000.000.000-009');
    else
      return this.maskPipe.transform(documento, '00.000.000/0000-00');
  }

}
